import type { LoadingRateSource } from '../components/core/TimeData';
import type { LoadingUnit } from '../graphql';
import { isDefined } from '../lib/util';

export const units: Record<LoadingUnit, string> = {
  METRIC_TONNES_PER_DAY: 'mts/day',
  /** m³/d */
  CUBIC_METERS_PER_DAY: 'cbm/day',
  /** ft³/d */
  CUBIC_FEET_PER_DAY: 'ft3/day',
  /** h */
  LOADING_IN_HOURS_FOR_THE_WHOLE_PARCEL: 'hours',
  /** t/h */
  METRIC_TONNES_PER_HOUR: 'mts/hour',
  /** m³/h */
  CUBIC_METERS_PER_HOUR: 'cbm/hour',
  /** ft³/h */
  CUBIC_FEET_PER_HOUR: 'ft3/hour',
  /** scbmub/h */
  SCBMUB_HOUR: 'scbmub/h',
  /** scbmub/d */
  SCBMUB_DAY: 'scbmub/d',
  /** scbmob/h */
  SCBMOB_HOUR: 'scbmob/h',
  /** scbmob/d */
  SCBMOB_DAY: 'scbmob/d',
  /** bdmt/h */
  BDMT_HOUR: 'bdmt/h',
  /** bdmt/d */
  BDMT_DAY: 'bdmt/d',
  /** admt/h */
  ADMT_HOUR: 'admt/h',
  /** admt/d */
  ADMT_DAY: 'admt/d',
  /** days */
  LOADING_IN_DAYS_FOR_THE_WHOLE_PARCEL: 'days',
};

export const reducedLoadingUnits = Object.entries(units).map(
  ([value, name]) => {
    if (
      [
        'METRIC_TONNES_PER_DAY',
        'METRIC_TONNES_PER_HOUR',
        'CUBIC_METERS_PER_DAY',
        'CUBIC_METERS_PER_HOUR',
        'CUBIC_FEET_PER_DAY',
        'CUBIC_FEET_PER_HOUR',
        'LOADING_IN_HOURS_FOR_THE_WHOLE_PARCEL',
        'LOADING_IN_DAYS_FOR_THE_WHOLE_PARCEL',
      ].includes(value)
    ) {
      return { value, name };
    }
  },
);

export const loadingUnits: Array<{
  value: LoadingUnit;
  name: string;
}> = Object.entries(units).map(([value, name]) => ({
  value: value as LoadingUnit,
  name,
}));

const loadingUnitOptions = (shouldUseReducedUnits: boolean = false) =>
  (shouldUseReducedUnits ? reducedLoadingUnits : loadingUnits)
    .filter(isDefined)
    .map(({ name, value }) => ({
      value,
      id: value,
      label: name,
    }));

export default loadingUnitOptions;

export const defaultLoadingUnit = loadingUnits[0];

export const loadingUnitToName = loadingUnits.reduce<{ [key: string]: string }>(
  (acc, { value, name }) => {
    acc[value] = name;
    return acc;
  },
  {},
);

export const loadingRateSourceToLabel: Record<LoadingRateSource, string> = {
  assortment: 'Commodity',
  coa: 'COA',
  order: 'Order/parcel',
  port: 'Port',
  vessel: 'Vessel',
  voyage_charter: 'Voyage charter',
  port_commodity: 'Port-Commodity L/D rate',
};
